var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"applyRecord"},[_c('serviceTable',{attrs:{"headList":_vm.headList,"dataList":_vm.dataList,"buttonList":_vm.buttonList,"background":true,"total":_vm.total,"currentPage":_vm.currentPage,"btnWidth":120},on:{"check":_vm.check,"submit":_vm.submit,"currentChange":_vm.currentChange}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63d01df0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/providerApply/applyRecord.vue
// module id = null
// module chunks = 